<template>
  <b-overlay :show="isAgencyConnecting" rounded="sm">
    <div class="convey-connect-home d-flex">
      <div
        v-if="currentAgency && !isAgencyConnecting"
        class="convey-connect-home--content px-2 py-2 px-md-4 py-md-4"
      >
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Connect",
  computed: {
    ...mapGetters("agency", [
      "currentAgency",
      "agencySettings",
      "isAgencyConnecting",
    ]),
  },
};
</script>

<style lang="scss">
.convey-connect-home {
  width: 100%;
  height: 100%;
  &--content {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
